import { render } from "./TransferTablePage.vue?vue&type=template&id=8a8531a0&scoped=true"
import script from "./TransferTablePage.vue?vue&type=script&lang=js"
export * from "./TransferTablePage.vue?vue&type=script&lang=js"

import "./TransferTablePage.vue?vue&type=style&index=0&id=8a8531a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8531a0"]])

export default __exports__